import React, { memo } from 'react'
import { HelmetProvider } from 'react-helmet-async'

import { NavbarStateProvider, NotificationsProvider, ThemeProvider } from '@affstore-ds/uikit'

import { getBrandConfig } from '../../../config/brands'
import { MAIN_NAV_MENU_LOCALSTORAGE_KEY } from '../../localStorage/constants'
import { getTagifyGlobalStyles } from '../../styles/tagifyGlobalStyles'
import { BaseProvidersPropertiesInterface } from './BaseProviders.types'

import '@affstore-ds/uikit/styles.css'

const { brandConfig } = getBrandConfig()
const colorThemes = brandConfig.theme?.defaultColorScheme ? { [brandConfig.theme.defaultColorScheme]: brandConfig.theme?.colorTheme } : {}

export const BaseProviders = memo(({ children, direction }: BaseProvidersPropertiesInterface) => (
  <ThemeProvider
    contentMinWidth={320}
    colorThemes={colorThemes}
    defaultColorScheme={brandConfig.theme?.defaultColorScheme || 'light'}
    getGlobalBodyStyles={getTagifyGlobalStyles}
    initialDirection={direction ?? 'ltr'}
    detectDirection
  >
    <NotificationsProvider />
    <NavbarStateProvider localStorageNavMenuKey={MAIN_NAV_MENU_LOCALSTORAGE_KEY}>
      <HelmetProvider>{children}</HelmetProvider>
    </NavbarStateProvider>
  </ThemeProvider>
))
BaseProviders.displayName = 'BaseProviders'
